"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tinycolor = require("@ctrl/tinycolor");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Breadcrumbs = {
  styles: function styles(theme) {
    return {
      root: {
        textTransform: "uppercase",
        fontWeight: 400,
        fontFamily: 'Raleway, "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        fontSize: 18,
        letterSpacing: 1.5,
        lineHeight: 1
      },
      item: {
        color: theme.colors.baseContrast085,
        "& a": {
          fontSize: 24,
          letterSpacing: 2,
          // TODO: add support for primaryDark and primaryLight variations as variables: https://jira.atg-corp.com/browse/DEV-103289
          color: new _tinycolor.TinyColor(theme.colors.primary).darken(22).toHexString(),
          "&:hover, &:focus-visible": {
            color: new _tinycolor.TinyColor(theme.colors.primary).darken(22).toHexString()
          }
        }
      },
      separatorIcon: {
        fill: theme.colors.baseContrast085
      }
    };
  }
};
var _default = exports.default = Breadcrumbs;